import { createContext, useContext } from "react";
import { useParams } from "react-router-dom";
import { useOrderDetails } from "../hooks/useOrderDetails";

const OrderDetailsContext = createContext(null);

export function OrderDetailsProvider({ children }) {
  const { id } = useParams();
  const orderId = id ?? null;
  const isNewOrder = orderId === "new";

  const query = useOrderDetails(orderId);

  const value = {
    orderId,
    isNewOrder,
    order: query.data ?? null,
    isLoading: query.isLoading,
    isError: query.isError,
    refetch: query.refetch,
  };

  return <OrderDetailsContext.Provider value={value}>{children}</OrderDetailsContext.Provider>;
}

export function useOrderDetailsContext() {
  const context = useContext(OrderDetailsContext);
  if (!context) {
    throw new Error("useOrderDetailsContext must be used within an OrderDetailsProvider");
  }
  return context;
}
